import { useState } from "react";
import { REVIEWS } from "@/content/site";

const Star = () => (
  <svg viewBox="0 0 20 20" className="h-4 w-4 fill-[#F6BB06]" aria-hidden="true"><path d="M10 1.5l2.6 5.5 6 .8-4.4 4.2 1.1 6-5.3-2.9-5.3 2.9 1.1-6L1.4 7.8l6-.8z" /></svg>
);

export const Stars = ({ className = "" }) => (
  <span role="img" aria-label="5 out of 5 stars" className={`inline-flex gap-0.5 ${className}`}><Star /><Star /><Star /><Star /><Star /></span>
);

const GoogleG = () => (
  <svg viewBox="0 0 48 48" className="h-5 w-5" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 13 4 4 13 4 24s9 20 20 20 20-9 20-20c0-1.3-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
  </svg>
);

const ReviewCard = ({ r, i }) => (
  <li className="flex flex-col bg-white p-7" data-testid={`review-card-${i}`}>
    <div className="flex items-center gap-3">
      <span aria-hidden="true" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-ink font-display text-sm font-semibold text-gold">{r.name.charAt(0).toUpperCase()}</span>
      <div>
        <p className="font-semibold leading-tight">{r.name}</p>
        <Stars className="mt-1" />
      </div>
    </div>
    <blockquote className="mt-4 flex-1 text-stone-600" lang={r.lang}><p>{r.text}</p></blockquote>
    <p className="mt-5 inline-flex items-center gap-2 text-xs text-stone-600"><GoogleG /> Posted on Google</p>
  </li>
);

export const Reviews = ({ initial = 3 }) => {
  const [open, setOpen] = useState(false);
  const more = REVIEWS.length - initial;
  return (
    <section className="section bg-paper" aria-labelledby="reviews-heading" data-testid="reviews-section">
      <div className="wrap">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="eyebrow mb-5">Patient Reviews</p>
            <h2 id="reviews-heading" className="h2">What Patients Say About VidaVital Medical</h2>
          </div>
          <div className="flex items-center gap-4 border border-line bg-white px-6 py-4" data-testid="reviews-summary">
            <GoogleG />
            <div>
              <p className="font-display text-lg font-bold tracking-wide">EXCELLENT</p>
              <Stars />
              <p className="text-sm text-stone-600">Based on <strong className="text-ink">46 reviews</strong> on Google</p>
            </div>
          </div>
        </div>
        <ul className="mt-10 grid gap-px bg-line md:grid-cols-3">
          {REVIEWS.slice(0, initial).map((r, i) => <ReviewCard key={r.name} r={r} i={i} />)}
        </ul>
        <ul id="more-reviews" hidden={!open} className="grid gap-px bg-line md:grid-cols-3" data-testid="more-reviews">
          {REVIEWS.slice(initial).map((r, i) => <ReviewCard key={r.name} r={r} i={i + initial} />)}
        </ul>
        {more > 0 && (
          <button type="button" className="btn-line mt-8" aria-expanded={open} aria-controls="more-reviews" onClick={() => setOpen((v) => !v)} data-testid="reviews-toggle">
            {open ? "Show fewer reviews" : `Show ${more} more reviews`}
          </button>
        )}
      </div>
    </section>
  );
};
